var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c('v-main',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c('router-view',{attrs:{"background-color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }